import { GetInventorySuccessResponseInfo, PagingOptions } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { IEditBusinessAggregateBusiness } from '../domains/entities/editBusinessAggregateBusiness';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { GetBaseBusinessSuccessResponseInfo } from '@/coreInfrastructureModule/axios/generated/baseBusinessManage';

/**
 * 個別編集ページ表示情報のadapter
 */
export class GetEditIndividualBusinessAdapter {
  /**
   * 取得した集計をIBusinessを含むIEditBusinessAggregateBusinessに変換する
   * @param response - 在庫管理のAPIから返ってきたデータ
   */
  public static adaptAggregateBusiness = (response: GetInventorySuccessResponseInfo) => {
    const res: IEditBusinessAggregateBusiness[] = [];
    response.data?.forEach((aggregateBusiness) => {
      const business = BusinessFactory.create({
        businessId: aggregateBusiness.aggregateBusinessId,
        warehouseNumber: aggregateBusiness.warehouseNumber,
        warehouse: aggregateBusiness.warehouse,
        supplierNumber: aggregateBusiness.supplierNumber,
        supplierName: aggregateBusiness.supplierName,
        businessNumber: aggregateBusiness.businessNumber,
        businessName: aggregateBusiness.businessName,
        package: aggregateBusiness.package?.toString(),
        unit: aggregateBusiness.unit,
        manufacturer: aggregateBusiness.manufacturer,
        leadTime: aggregateBusiness.leadTime,
        leadTimeUnit: aggregateBusiness.leadTimeUnit,
        MOQ: aggregateBusiness.moq,
        stdInventoryIndices: {
          標準在庫指数: {
            max: aggregateBusiness.standardInventoryIndexMax ?? 0,
            min: aggregateBusiness.standardInventoryIndexMin ?? 0,
            option: {
              unit: aggregateBusiness.standardInventoryIndexUnit ?? '',
            },
          },
        },
        updatedAt: aggregateBusiness.updateAt,
      });
      res.push({ ...business, children: [], childrenAsyncStatus: 'none' });
    });
    return {
      result: res,
      pagingOptions: { ...(response.pagingOptions as PagingOptions) },
    };
  };

  /**
   *
   * 取得した集計に紐づく子取引をIBusinessに変換する
   * @param response - 在庫管理のAPIから返ってきたデータ
   */
  public static adaptChildBusiness = (response: GetBaseBusinessSuccessResponseInfo) => {
    const res: IBusiness[] = [];
    response.data?.forEach((business) => {
      res.push(
        BusinessFactory.create({
          businessId: business.baseBusinessId,
          warehouseNumber: business.warehouseNumber,
          warehouse: business.warehouse,
          supplierNumber: business.supplierNumber,
          supplierName: business.supplierName,
          businessNumber: business.businessNumber,
          businessName: business.businessName,
          package: business.package?.toString(),
          unit: business.unit,
          manufacturer: business.manufacturer,
          leadTime: business.leadTime,
          leadTimeUnit: business.leadTimeUnit,
          MOQ: business.moq,
          stdInventoryIndices: {
            標準在庫指数: {
              max: business.standardInventoryIndexMax ?? 0,
              min: business.standardInventoryIndexMin ?? 0,
              option: {
                unit: business.standardInventoryIndexUnit ?? '',
              },
            },
          },
          customerNumber: business.customerNumber,
          customerName: business.customerName,
          salesDestinationNumber: business.salesDestinationNumber,
          salesDestinationName: business.salesDestinationName,
          endUser: business.endUser,
          updatedAt: business.updateAt,
        })
      );
    });
    return {
      result: res,
      pagingOptions: { ...(response.pagingOptions as PagingOptions) },
    };
  };
}
